<script lang="ts">
	import Logo from '$lib/domain/logo/Logo.svelte'
	import { membership } from '$lib/domain/membership/membership'
	import { tenantSettings } from '$lib/domain/tenantSettings/tenantSettings'
	import { environmentDomain } from '@helpers/settings'
	import { _ } from '@repo/i18n'
	import { MembershipsV1PlanId } from '@sdk/Api'

	interface Props {
		center?: boolean
	}

	let { center = false }: Props = $props()

	const releaseDate = new Date('2024-12-06')

	let isAfterReleaseDate = $derived(new Date($tenantSettings.registeredAt) > releaseDate)
</script>

<div class="grid max-w-sm grid-cols-1 gap-2.5 rounded-md bg-gray-100 px-4 py-2.5 dark:bg-gray-700">
	<div class="text-gray-500 {center ? 'text-center' : ''} dark:text-gray-400">
		{#if isAfterReleaseDate}
			{$_('footer.affiliateProgramPoweredBy')}
			<a class="underline hover:no-underline" href="//{environmentDomain}">Trackdesk</a>
			<br />
			{$_('footer.bestOnMarket')}
		{:else}
			<a class="underline hover:no-underline" href="//{environmentDomain}">
				{$membership.planId === MembershipsV1PlanId.PLAN_ID_FREEMIUM
					? $_('footer.freeAffiliateSoftware')
					: $_('footer.affiliateTrackingSoftware')}
			</a>
			{$_('footer.poweredByTrackdesk')}
		{/if}
	</div>
	<a
		class="flex h-[15px] w-[90px] items-center {center ? 'm-auto' : ''}"
		href="//{environmentDomain}"
	>
		<Logo />
	</a>
</div>
